module.exports = __webpack_public_path__ + "img/position-id.834496e1.svg";